import { DefaultSettings } from './default';
import { version } from '../../package.json';

// ACHTUNG: Werden hier Parameter aufgenommen, sind diese auch im Dockerfile für das "envsubst" zu ergänzen.

const tmcBaseUrl = '${TMC_BASE_URL}';
const tmcclientUrl = '${TMC_CLIENT_URL}';
const tmcCustomer = '${TMC_CUSTOMER}';
const simulatorEnabledString = '${TMC_SIMULATOR_ENABLED}';
const scanNumberplateAvailableString = '${TMC_SCANNUMBERPLATE_ENABLED}';
const authenticationStrategy = '${TMC_AUTHENTICATION_STRATEGY}';
const oAuth2SkipIssuerCheck = '${TMC_OAUTH2_ISSUER_SKIP_CHECK}';
const oAuth2Issuer = '${TMC_OAUTH2_ISSUER}';
const oAuth2ClientId = '${TMC_OAUTH2_CLIENTID}';
const oAuth2RequestedScopes = '${TMC_OAUTH2_REQUESTEDSCOPES}';
const oAuth2LoginEndpoint = '${TMC_OAUTH2_AUTHORIZE_URL}';
const oAuth2TokenEndpoint = '${TMC_OAUTH2_TOKEN_URL}';
const oAuth2LogoutEndpoint = '${TMC_OAUTH2_LOGOUT_URL}';

const devFeatureYardMapAdministrationEnabled = '${FEATURE_YARD_MAP_ADMINISTRATION_ENABLED}';
const devFeatureDocumentTemplateAdministrationEnabled = '${FEATURE_DOCUMENT_TEMPLATE_ADMINISTRATION_ENABLED}';
const enableLoggingString = '${TMC_LOGGING_ENABLED}';
const onlyWizardsAvailableString = '${TMC_ONLY_WIZARDROUTE_ENABLED}';

export const environment = {
  ...DefaultSettings.get(tmcBaseUrl, tmcclientUrl),
  production: true,
  enableLogging: enableLoggingString.toLowerCase().replace('true','').length === 0,
  customer: tmcCustomer,
  autoreload: true,

  onlyWizardsAvailable: onlyWizardsAvailableString.toLowerCase().replace('true','').length === 0,
  
  product: 'TMC YARD',
  title: 'TMC YARD',
  supportTitle: 'TMC YARD Support',
  supportPhone: '+49 721 90997171',
  supportMail: 'support@sdbn-solutions.de',

  simulatorAvailable: simulatorEnabledString,
  scanNumberplateAvailable: scanNumberplateAvailableString.toLocaleLowerCase() === 'true',

  authenticationStrategy,
  // OAUTH COnfig for Azure AD
  oAuth2Issuer,
  // Client ID must be fix for AzureAD and OAUTH2
  oAuth2ClientId,
  oAuth2SkipIssuerCheck: oAuth2SkipIssuerCheck.toLowerCase() === 'true',
  oAuth2RequestedScopes,
  oAuth2LoginEndpoint,
  oAuth2TokenEndpoint,
  oAuth2LogoutEndpoint,
  devFeatureYardMapAdministrationEnabled: devFeatureYardMapAdministrationEnabled.toLocaleLowerCase() === 'true',
  devFeatureDocumentTemplateAdministrationEnabled: devFeatureDocumentTemplateAdministrationEnabled.toLocaleLowerCase() === 'true'
};
